import { cn } from "@/lib/utils";

const sizes = {
  sm:  "h-3 w-3",
  md:  "h-5 w-5",
  lg:  "h-8 w-8",
  xl:  "h-12 w-12",
};

/**
 * Standalone spinner for page-level and section loading states.
 * The Button component has its own inline spinner - use this for everything else.
 *
 * Usage:
 *   <Spinner />                         // default md, inherits text color
 *   <Spinner size="lg" className="text-primary" />
 *   <Spinner size="xl" label="Loading report..." /> // with accessible label
 */
function Spinner({ size = "md", className, label = "Loading..." }) {
  return (
    <span role="status" aria-label={label} className={cn("inline-flex", className)}>
      <svg
        className={cn("animate-spin", sizes[size] ?? sizes.md)}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12" cy="12" r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
    </span>
  );
}

/**
 * Full-area loading state - centred spinner with optional message.
 * Drop inside any container that is loading.
 *
 * Usage:
 *   <SpinnerPage />
 *   <SpinnerPage message="Loading Report Folders..." />
 */
function SpinnerPage({ message }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-20 text-muted-foreground">
      <Spinner size="lg" className="text-primary" />
      {message && <p className="text-sm font-sans">{message}</p>}
    </div>
  );
}

export { Spinner, SpinnerPage };
